<template>
	<TripFormSection
		icon="calendar"
		:is-complete="isComplete()"
		:title="$t('web.edit.trip.dates.title')"
	>
		<div class="d-flex gap-3 flex-wrap">
			<div class="d-flex flex-1">
				<InputDatePicker
					:model-value="startDate"
					size="s"
					:max-date="endDate"
					@input="onInputStartDate"
				/>
			</div>
			<div class="d-flex flex-1">
				<InputDatePicker
					:model-value="endDate"
					size="s"
					:min-date="startDate"
					@input="onInputEndDate"
				/>
			</div>
		</div>
	</TripFormSection>
</template>

<script setup lang="ts">
	interface Props {
		startDate?: string
		endDate?: string
		isXS: boolean
		isMobile: boolean
	}
	const props = defineProps<Props>()

	const emit = defineEmits<{
		(e: 'update:start-date', value: string | undefined): void
		(e: 'update:end-date', value: string | undefined): void
	}>()

	const isComplete = (): boolean => {
		const hasDates = props.startDate && props.endDate
		return Boolean(hasDates)
	}

	const onInputStartDate = (event: Event) => {
		const value = (event.target as HTMLInputElement).value
		emit('update:start-date', value)
	}

	const onInputEndDate = (event: Event) => {
		const value = (event.target as HTMLInputElement).value
		emit('update:end-date', value)
	}
</script>

<style scoped>
	.duration-period-chip:hover:not(.selected) {
		background: var(--color-primary-50);
	}
</style>
